module.exports = __webpack_public_path__ + "static/media/chess-rook-alt.b8a68ec1.svg";